module.exports = __webpack_public_path__ + "img/m5fudongmu.asm.7fba1dfc.jpg";